import React from 'react';
import classnames from 'classnames';
import * as styles from './button.scss';
import MyMenigoIcon from '../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
export default (props) => (React.createElement("button", { type: "button", onClick: props.onClick, className: classnames(styles.base, props.className), ref: el => props.element && props.element(el) },
    React.createElement(MyMenigoIcon, { name: "search" })));
